import { useFormik } from "formik";
import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from "react-dropdown-select";

interface LinkNewCategoryModalFormProps {
  onCreateNewCategory: (userDetails: any) => void;
  stateListForDropdown: {
    stateName: string;
    stateId: number;
  }[];
  categoryListForDropdown: {
    categoryName: string;
    categoryId: number;
  }[];
}

const LinkNewCategoryModalForm: React.FC<LinkNewCategoryModalFormProps> = ({
  onCreateNewCategory,
  stateListForDropdown,
  categoryListForDropdown,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
  };
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      stateIds: [], // Ensure it's an empty array for multi-select
      categoryIds: [],
    },
    onSubmit: (values, { resetForm }) => {
      onCreateNewCategory(values);
      resetForm();
      handleModalClose();
    },
  });

  return (
    <>
      {
        <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
          Link New Category
        </Button>
      }
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {"Add New Category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
          <Form.Group className="mb-3" controlId="findState">
              <Form.Label>State</Form.Label>
              <Select
                required
                options={stateListForDropdown}
                labelField="stateName"
                valueField="stateId"
                searchable
                searchBy={"stateName"}
                values={formik.values.stateIds} // Ensure it's an array
                onChange={
                  (selectedValues) =>{
                    formik.setFieldValue("stateIds", selectedValues.map((item)=>item.stateId)) // Correct way to update Formik
                }}
                onClearAll={() => formik.setFieldValue("stateIds", [])}
                multi
                selectAll
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="findState">
              <Form.Label>Category</Form.Label>
              <Select
                options={categoryListForDropdown}
                labelField="categoryName"
                valueField="categoryId"
                searchable
                searchBy={"categoryName"}
                required={true}
                values={formik.values.categoryIds} // Ensure it's an array
                onChange={
                  (selectedValues) =>
                    formik.setFieldValue("categoryIds", selectedValues.map((item)=>item.categoryId)) // Correct way to update Formik
                }
                onClearAll={() => formik.setFieldValue("categoryIds", [])}
                multi
                selectAll
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>
            {"Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LinkNewCategoryModalForm;
